import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { ExaminationForm } from '@pixacare/domain';
import { TuiButton, TuiDataList, TuiDropdown, TuiDropdownOpen, TuiIcon, TuiRadio } from '@taiga-ui/core';
import { TuiChevron, TuiDataListWrapper } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-examination-selector',
  templateUrl: './examination-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiDropdown,
    TuiDropdownOpen,
    TuiChevron,
    TuiRadio,
    TuiDataList,
    TuiDataListWrapper,
    TuiButton,
    TuiIcon,
    TranslocoDirective,
  ],
})
export class ExaminationSelectorComponent {
  @Input() examinationForms: ExaminationForm[] = [];
  @Input() selectedExaminationForm: ExaminationForm | null = null;
  @Output() readonly selectedExaminationFormChange = new EventEmitter<ExaminationForm>();

  open = false;

  stringify(item: ExaminationForm): string {
    return item.title;
  }

  select(item: ExaminationForm): void {
    this.open = false;
    this.selectedExaminationFormChange.emit(item);
  }
}
